/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_RetentionInputs */

const en_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retention Period`)
};

const de_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherdauer`)
};

const fr_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree de conservation`)
};

const es_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo de retencion`)
};

const it_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo di conservazione`)
};

const nl_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewaartermijn`)
};

const pl_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okres przechowywania`)
};

const fi_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säilytysaika`)
};

const da_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opbevaringsperiode`)
};

const sv_privacy_table_header_retention = /** @type {(inputs: Privacy_Table_Header_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagringsperiod`)
};

/**
* | output |
* | --- |
* | "Retention Period" |
*
* @param {Privacy_Table_Header_RetentionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_retention = /** @type {((inputs?: Privacy_Table_Header_RetentionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_RetentionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_retention(inputs)
	if (locale === "fr") return fr_privacy_table_header_retention(inputs)
	if (locale === "es") return es_privacy_table_header_retention(inputs)
	if (locale === "it") return it_privacy_table_header_retention(inputs)
	if (locale === "nl") return nl_privacy_table_header_retention(inputs)
	if (locale === "pl") return pl_privacy_table_header_retention(inputs)
	if (locale === "fi") return fi_privacy_table_header_retention(inputs)
	if (locale === "da") return da_privacy_table_header_retention(inputs)
	if (locale === "sv") return sv_privacy_table_header_retention(inputs)
	return en_privacy_table_header_retention(inputs)
});